import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../config/firebase';
import {
    signInWithEmailAndPassword,
} from 'firebase/auth';
import axios from 'axios';
import './LoginOvi.css';
import Alert from '../../components/Alert/Alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const LoginOvi = () => {
    const [cell, setCell] = useState('');
    const [password, setPassword] = useState('');
    const [showPass, setShowPass] = useState(false);
    const navigate = useNavigate();
    const [alert, setAlert] = useState(null);

    const sendTokenToBackend = async (token) => {
        try {
            const response = await axios.post(
                'https://api.minymol.com/auth/login',
                { token }
            );

            const userData = response.data;

            localStorage.setItem('usuario', JSON.stringify(userData));
            localStorage.setItem('token', token);

            navigate('/my-products');
        } catch (error) {
            console.error('Error desde el backend:', error);
            if (error.response?.status === 401) {
                setAlert({
                    type: 'error',
                    message: 'Token inválido o usuario no autorizado',
                });
            } else {
                setAlert({
                    type: 'error',
                    message: 'No se pudo autenticar con el servidor',
                });
            }
        }
    };

    const loginWithEmail = async (e) => {
        e.preventDefault();

        const isEmail = cell.includes('@');
        const fakeEmail = isEmail ? cell.trim().toLowerCase() : cell.replace('+', '') + '@minymol.com';

        try {
            const result = await signInWithEmailAndPassword(auth, fakeEmail, password);
            const token = await result.user.getIdToken();
            await sendTokenToBackend(token);
        } catch (err) {
            console.error('Error con correo/contraseña:', err);
            setAlert({
                type: 'error',
                message: 'Correo o contraseña incorrectos',
            });
        }
    };

    return (
        <div className="loginovi-container">
            {alert && (
                <Alert
                    type={alert.type}
                    message={alert.message}
                    onClose={() => setAlert(null)}
                    redirectTo={alert.redirectTo}
                />
            )}

            <div className="loginovi-gradient-bg"></div>

            <div className="loginovi-card">
                <div className="loginovi-header">
                    <div className="loginovi-logo">
                        <svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                                <linearGradient id="ovi-login-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" stopColor="#4169E1" />
                                    <stop offset="50%" stopColor="#8B5CF6" />
                                    <stop offset="100%" stopColor="#10B981" />
                                </linearGradient>
                            </defs>
                            <circle cx="30" cy="30" r="25" fill="none" stroke="url(#ovi-login-gradient)" strokeWidth="3" opacity="0.3" />
                            <path d="M 18 24 L 18 36 Q 18 39 21 39 L 28.5 39 L 28.5 21 L 21 21 Q 18 21 18 24 Z"
                                fill="url(#ovi-login-gradient)" />
                            <path d="M 31.5 21 L 31.5 39 L 39 39 Q 42 39 42 36 L 42 24 Q 42 21 39 21 Z"
                                fill="url(#ovi-login-gradient)" opacity="0.8" />
                            <line x1="30" y1="21" x2="30" y2="39" stroke="#ffffff" strokeWidth="1" opacity="0.3" />
                        </svg>
                    </div>
                    <h1 className="loginovi-title">OviCatalogos</h1>
                    <p className="loginovi-subtitle">Inicia sesión en tu cuenta</p>
                </div>

                <form onSubmit={loginWithEmail} className="loginovi-form">
                    <div className="loginovi-input-group">
                        <label className="loginovi-label">Número de celular</label>
                        <input
                            type="text"
                            required
                            placeholder="Ej.: 3101234567"
                            value={cell}
                            onChange={(e) => setCell(e.target.value)}
                            className="loginovi-input"
                        />
                    </div>

                    <div className="loginovi-input-group">
                        <label className="loginovi-label">Contraseña</label>
                        <div className="loginovi-password-wrapper">
                            <input
                                type={showPass ? 'text' : 'password'}
                                placeholder="Contraseña"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className="loginovi-input"
                            />
                            <span className="loginovi-toggle-pass" onClick={() => setShowPass(!showPass)}>
                                <FontAwesomeIcon icon={showPass ? faEyeSlash : faEye} />
                            </span>
                        </div>
                    </div>

                    <button className="loginovi-btn-submit" type="submit">
                        Iniciar sesión
                    </button>
                </form>

                <div className="loginovi-footer">
                    <p className="loginovi-footer-text">
                        ¿No tienes cuenta?{' '}
                        <a href="/registerovi" className="loginovi-link">Regístrate aquí</a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default LoginOvi;
